
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import PricingHero from '@/components/pricing/PricingHero';
import PricingTiers from '@/components/pricing/PricingTiers';
import PricingFAQ from '@/components/pricing/PricingFAQ';
import FinalCTA from '@/components/FinalCTA';
import SectionLayout from '@/components/SectionLayout';

const Pricing = () => {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <PricingHero />
      
      {/* Pricing Tiers */}
      <SectionLayout 
        backgroundColor="bg-white" 
        paddingY="py-16 md:py-24"
        containerWidth="wide"
      >
        <PricingTiers />
      </SectionLayout>
      
      {/* FAQ Section */}
      <SectionLayout 
        backgroundColor="bg-[#FEE6D8]/30" 
        paddingY="py-16 md:py-24"
        backgroundPattern="soft-mesh"
        patternOpacity={3}
      >
        <PricingFAQ />
      </SectionLayout>
      
      {/* Final CTA */}
      <SectionLayout 
        backgroundColor="bg-white" 
        paddingY="py-16 md:py-24"
      >
        <FinalCTA />
      </SectionLayout>
      
      <Footer />
    </main>
  );
};

export default Pricing;
